module.exports = __webpack_public_path__ + "696c0dec3e574c56021a7f7f94296b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/picture/Dining.jpg
// module id = 548
// module chunks = 0